function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#fff",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  strokeMiterlimit: 9,
  stroke: "#002060",
  fill: "none",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  className: "icon-tertiary"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  transform: "matrix(1.1523,0,0,1.1559,-6.7194,-2.0252)"
}, React.createElement("path", {
  strokeWidth: 1.446,
  fill: "#fff",
  d: "m22.271 25.663c0-1.586 1.4228-2.8721 3.1811-2.8721s3.1811 1.2861 3.1811 2.8721-1.4228 2.8721-3.1811 2.8721-3.1811-1.2861-3.1811-2.8721z"
}), React.createElement("path", {
  strokeWidth: 0.57766,
  fill: "#adb9ca",
  d: "m25.535 23.468c-1.1567 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007 1.1568 0 2.0937-0.89552 2.0937-2.0007 0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.78081-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  className: "icon-secondary"
}), React.createElement("path", {
  strokeWidth: 0.86648,
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m25.675 23.468c-1.1568 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007s2.0937-0.89552 2.0937-2.0007c0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.7808-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  className: "icon-tertiary"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(.7261 0 0 .72837 9.679 -.14558)"
}, React.createElement("path", {
  strokeWidth: 1.4542,
  opacity: 0.99,
  fillRule: "evenodd",
  fill: "#ecaec6",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  className: "icon-primary"
}), React.createElement("path", {
  strokeWidth: 1.3751,
  strokeMiterlimit: 8,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  className: "icon-tertiary"
}), React.createElement("circle", {
  strokeWidth: 1.3751,
  strokeMiterlimit: 8,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "#fff",
  r: 3.2945,
  cy: 37.876,
  cx: 18.16,
  className: "icon-tertiary"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#002060",
  fillRule: "evenodd"
}, React.createElement("path", {
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#fff",
  d: "m16 6.4456 8.6176 5.263 0.01048 1e-3 0.04193 0.026 0.25161 0.158h-0.01048l0.13629 0.088c0.24113 0.229 0.3879 0.545 0.3879 0.895v8.302c0 0.7-0.59757 1.267-1.321 1.267h-16.229c-0.72338 0-1.321-0.567-1.321-1.267v-8.302c0-0.35 0.14677-0.666 0.3879-0.895l0.13629-0.088h-0.010484l0.25161-0.158 0.041935-0.026 0.010484-1e-3z",
  className: "icon-tertiary"
}), React.createElement("path", {
  strokeWidth: 0.66667,
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#ecaec6",
  d: "m10.08 5.4456h11.84c0.32 0 0.58 0.259 0.58 0.577v6.688l-6.5 3.735-6.5-3.729v-6.694c0-0.318 0.26-0.577 0.58-0.577z",
  className: "icon-primary"
}), React.createElement("g", {
  strokeWidth: 1.047,
  strokeMiterlimit: 8,
  fill: "#fff",
  transform: "matrix(.91223 0 0 1 2.0775 -1.0748)",
  className: "icon-tertiary"
}, React.createElement("path", {
  d: "m6.8571 22.264 6.3653-3.7442"
}), React.createElement("path", {
  d: "m23.227 22.264-6.37-3.744"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fillRule: "evenodd",
  fill: "none",
  d: "m10.08 5.4456h11.84c0.32 0 0.58 0.259 0.58 0.577v6.688l-6.5 3.735-6.5-3.729v-6.694c0-0.318 0.26-0.577 0.58-0.577z",
  className: "icon-tertiary"
});

var SvgSidepanelDataActions = function SvgSidepanelDataActions(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    height: 40,
    width: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, React.createElement("g", {
    style: {
      fontSize: "8.73135px",
      lineHeight: 1.25,
      fontFamily: "'Open Sans'",
      InkscapeFontSpecification: "'Open Sans'",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      fill: "#002060",
      fillOpacity: 1,
      strokeWidth: 0.999999
    },
    transform: "scale(1.0241244,0.97644388)",
    "aria-label": "@"
  }, React.createElement("path", {
    style: {
      strokeWidth: 0.999999
    },
    d: "m 19.061402,9.9909459 q 0,0.6053961 -0.187587,1.1084721 -0.187588,0.503076 -0.528656,0.780194 -0.341069,0.277118 -0.784458,0.277118 -0.366648,0 -0.618186,-0.221694 -0.251538,-0.221695 -0.298435,-0.567027 h -0.03411 q -0.170534,0.370912 -0.490285,0.579817 -0.315489,0.208904 -0.750351,0.208904 -0.639503,0 -1.001888,-0.434862 -0.358122,-0.439126 -0.358122,-1.189476 0,-0.8697244 0.503076,-1.4111704 0.503076,-0.5457094 1.32164,-0.5457094 0.289908,0 0.656557,0.055424 0.366648,0.05116 0.660819,0.1449541 l -0.106583,2.0037761 v 0.09379 q 0,0.758877 0.567026,0.758877 0.387965,0 0.630976,-0.456179 0.243011,-0.460442 0.243011,-1.1937388 0,-0.7716672 -0.315488,-1.3514834 -0.315488,-0.5798162 -0.899568,-0.8910411 -0.579816,-0.3154882 -1.33443,-0.3154882 -0.950728,0 -1.654181,0.396492 -0.703454,0.3922286 -1.074365,1.1255256 -0.370912,0.7290336 -0.370912,1.6882879 0,1.300324 0.6864,1.999514 0.6864,0.69919 1.978196,0.69919 0.895305,0 1.858823,-0.366649 v 0.567026 q -0.818564,0.358122 -1.858823,0.358122 -1.547597,0 -2.404532,-0.848407 -0.852671,-0.852671 -0.852671,-2.378952 0,-1.1084722 0.456179,-1.9739332 0.456179,-0.865461 1.300324,-1.3386933 0.844144,-0.4774957 1.935562,-0.4774957 0.916622,0 1.628602,0.3879652 0.716243,0.383702 1.104209,1.0956821 0.392228,0.7077169 0.392228,1.6328648 z m -4.408308,0.5584991 q 0,1.082892 0.831354,1.082892 0.882514,0 0.959255,-1.33443 l 0.05969,-1.1127351 q -0.306962,-0.085267 -0.669347,-0.085267 -0.554236,0 -0.869724,0.3837019 -0.311225,0.3837019 -0.311225,1.0658383 z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelDataActions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-data-actions.b98446b3.svg";
export { ForwardRef as ReactComponent };